/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { displayMessage, getAPI, postAPI } from "../../utils/common";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import {
  Space,
  Button,
  Card,
  Popconfirm,
  Layout,
  Table,
  Tag,
  Input,
  Select,
  Col,
  Row,
  Modal,
} from "antd";
import {
  ALL_BOOKING,
  BOOKING_ACTION,
  BOOKING_ADV_PAY,
  BOOKING_ADV_PAY_VERIFY,
  BOOKING_CHECKIN,
  BOOKING_INVOICE,
  BOOKING_MULTI_INVOICE,
  BOOKING_PAY,
  BOOKING_PAY_VERIFY,
  IMAGE_BASE_URL,
} from "../../constants/api";
import { useLocation, useNavigate } from "react-router-dom";
import {
  BUSINESS_SEGMENT_IMG,
  capitalizeWords,
  CURRENCY,
  getBookingType,
  getSegmentLabel,
  PAYMENT_METHOD,
} from "../../constants/constent";
import BookingDetailDrawer from "./BookingDetailDrawer";
import CheckoutModal from "./CheckoutModal";
import moment from "moment";
import {
  ERROR_MSG_TYPE,
  INFO_MSG_TYPE,
  SUCCESS_MESSAGE,
} from "../../constants/messages";
import BookingOrderDrawer from "./BookingOrderDrawer";
import ExtraServiceModal from "./extra_service/ExtraServiceModal";
import BookingAppliedServiceModal from "./BookingAppliedServiceModal";
import LS_SERVICE from "../../utils/localStorage";
import BookingEditModal from "./BookingEditModal";
import CancelBookingModal from "./CancelBookingModal";

function BookingTable() {
  const { Content } = Layout;
  const navigate = useNavigate();

  const [state, setState] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  // Get the search (query params) from the URL
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get("type"); // Extract type from URL
  // Advance Amount
  const [advModalVisible, setAdvModalVisible] = useState(false);
  const [advanceAmount, setAdvanceAmount] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  // Booking View
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  // Booking Order  View
  const [isOrderDrawerOpen, setIsOrderDrawerOpen] = useState(false);
  // Booking Checkout
  const [isModalVisible, setIsModalVisible] = useState(false);
  // Booking Cancel
  const [isCancelModalVisible, setIsCancelModalVisible] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [selectedBookingId, setSelectedBookingId] = useState(null);
  const [cancelBooking, setCancelBooking] = useState(null);

  // Edit Booking Modal
  const [editBookingVisible, setEditBookingVisible] = useState(false);

  // Booking View
  const openDrawer = (room) => {
    setSelectedBooking(room);
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
    setSelectedBooking(null);
  };

  // Booking Detail View
  const openOrderDrawer = (room) => {
    setSelectedBooking(room);
    setIsOrderDrawerOpen(true);
  };

  const closeOrderDrawer = () => {
    setIsOrderDrawerOpen(false);
    setSelectedBooking(null);
  };

  // Booking Checkout
  const openModel = (room) => {
    setSelectedBooking(room);
    console.log("room :", room);
    console.log("setSelectedBooking :", selectedBooking);
    setIsModalVisible(true);
  };

  const handleClose = () => {
    setEditBookingVisible(false);
    setIsServicesModal(false);
    setIsServiceModal(false);
    setIsModalVisible(false);
    setSelectedBooking(null);
    getData();
  };

  useEffect(() => {
    if (type) {
      getData();
    }
  }, [type]);

  const bookingAction = (id, action_type) => {
    setLoading(true);
    let body = {
      id: id,
      action_type: action_type,
      reason: cancelReason ?? "",
      cancel_by: LS_SERVICE.get("user_type") ?? "",
    };

    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        getData();
        if (action_type === "reject") {
          setIsCancelModalVisible(false);
          setCancelReason("");
          setSelectedBookingId(null);
        }
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to action");
    };
    postAPI(BOOKING_ACTION, body, successFn, errorFn);
  };

  const adv_pay_init = (id, advAmount) => {
    setLoading(true);
    let body = {
      id: id,
      total_amount: advAmount,
      payment_method: paymentMethod,
      force_check_in: "yes",
    };
    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);

        if (data.payment_method === "razorpay") {
          const options = {
            key: data.options.key,
            amount: data.options.amount * 100,
            currency: data.options.currency,
            name: data.options.name,
            description: data.options.description,
            image: IMAGE_BASE_URL + data.options.image,
            order_id: data.options.order_id,
            prefill: {
              name: data.options.prefill.name,
              email: data.options.prefill.email,
              contact: data.options.prefill.contact,
            },
            handler: function (response) {
              let body = {
                ...response,
                booking_id: id,
                total_amount: advAmount,
              };
              console.log(body);
              const successFn = function (data) {
                displayMessage(SUCCESS_MESSAGE, data.message);
                setAdvanceAmount("");
                setSelectedBooking(null);
                getData();
              };
              const errorFn = function () {
                setLoading(false);
                displayMessage(
                  ERROR_MSG_TYPE,
                  "Unable to do payment verification",
                );
              };
              postAPI(BOOKING_ADV_PAY_VERIFY, body, successFn, errorFn);
            },
            theme: {
              color: "#F37254",
            },
          };
          const razorpay = new window.Razorpay(options);
          razorpay.open();
        } else {
          displayMessage(SUCCESS_MESSAGE, data.message);
          setAdvanceAmount("");
          setSelectedBooking(null);
          getData();
        }
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };

    // Error callback
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to do payment");
    };

    // Make API call to your backend to initiate Razorpay
    postAPI(BOOKING_ADV_PAY, body, successFn, errorFn);
  };
  const pay_init = (id) => {
    setLoading(true);
    let body = {
      id: id,
    };
    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        displayMessage(SUCCESS_MESSAGE, data.message);

        const options = {
          key: data.options.key,
          amount: data.options.amount * 100,
          currency: data.options.currency,
          name: data.options.name,
          description: data.options.description,
          image: IMAGE_BASE_URL + data.options.image,
          order_id: data.options.order_id,
          prefill: {
            name: data.options.prefill.name,
            email: data.options.prefill.email,
            contact: data.options.prefill.contact,
          },
          handler: function (response) {
            let body = {
              ...response,
              booking_id: id,
            };
            console.log(body);
            const successFn = function (data) {
              displayMessage(SUCCESS_MESSAGE, data.message);
              getData();
            };
            const errorFn = function () {
              setLoading(false);
              displayMessage(
                ERROR_MSG_TYPE,
                "Unable to do payment verification",
              );
            };
            postAPI(BOOKING_PAY_VERIFY, body, successFn, errorFn);
          },
          theme: {
            color: "#F37254",
          },
        };
        const razorpay = new window.Razorpay(options);
        razorpay.open();
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };

    // Error callback
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to do payment");
    };

    // Make API call to your backend to initiate Razorpay
    postAPI(BOOKING_PAY, body, successFn, errorFn);
  };

  const checkin = (id) => {
    setLoading(true);
    let body = {
      booking_id: id,
    };
    console.log(body);
    const successFn = function (data) {
      setLoading(false);
      displayMessage(
        data.status ? SUCCESS_MESSAGE : ERROR_MSG_TYPE,
        data.message,
      );
      getData();
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Check-In");
    };
    postAPI(BOOKING_CHECKIN, body, successFn, errorFn);
  };

  const getData = () => {
    setLoading(true);
    const successFn = function (data) {
      if (data.status === true) {
        const roomData = data["data"].map((row, index) => ({
          key: index,
          ID: index + 1,
          room_no_n: row.room_no,
          booking_status_n:
            row.booking_status === "0"
              ? "Pending"
              : row.booking_status === "1"
                ? "OnGoing"
                : row.booking_status === "2"
                  ? "Completed"
                  : row.booking_status === "3"
                    ? "Canceled"
                    : row.booking_status === "4"
                      ? "Accepted"
                      : "Unknown",
          order_id: row.order_id,
          invoice_id: row.invoice_id,
          multi_book_id: row.multi_book_id,
          room_no: <Tag color="green">{row.room_no}</Tag>,
          name: row.customer_name,
          segment: (
            <>
              {capitalizeWords(
                getSegmentLabel(row.booking_segment) +
                  " (" +
                  row.booking_source.toUpperCase() +
                  ") ",
              )}
              <img
                style={{ width: "25px" }}
                src={
                  BUSINESS_SEGMENT_IMG[getBookingType(row)] ||
                  BUSINESS_SEGMENT_IMG.others
                }
                alt={row.booking_source}
                title={row.booking_source}
              />
            </>
          ),
          phone: row.user.phone,
          room_price: `${CURRENCY} ${row.room_price}`,
          total_amount: `${CURRENCY} ${row.total_amount}`,
          advance_amount: `${CURRENCY} ${row.advance_amount}`,
          checkin_date: moment(row.checkin_date).format("MMMM Do, YYYY"),
          checkout_date: moment(row.checkout_date).format("MMMM Do, YYYY"),
          booking_status: (
            <Tag
              color={
                row.booking_status === "0"
                  ? "yellow"
                  : row.booking_status === "1"
                    ? "green"
                    : row.booking_status === "2"
                      ? "blue"
                      : row.booking_status === "3"
                        ? "red"
                        : "gray"
              }
            >
              {row.booking_status === "0"
                ? "Pending"
                : row.booking_status === "1"
                  ? "OnGoing"
                  : row.booking_status === "2"
                    ? "Completed"
                    : row.booking_status === "3"
                      ? "Canceled"
                      : row.booking_status === "4"
                        ? "Accepted"
                        : "Unknown"}
            </Tag>
          ),
          payment_status: (
            <Tag
              color={
                row.payment_status === "2"
                  ? "red"
                  : row.payment_status === "1"
                    ? "green"
                    : row.payment_status === "0"
                      ? "blue"
                      : "gray"
              }
            >
              {row.payment_status === null || row.payment_status === "0"
                ? "Payment Pending"
                : row.payment_status === "1"
                  ? "Payment Done"
                  : row.payment_status === "2"
                    ? "Payment Fail"
                    : "Unknown" || "-"}
            </Tag>
          ),
          Action: (
            <Row gutter={[8, 8]}>
              {type !== "multi_booking" && (
                <Col span={24}>
                  <Button
                    loading={loading}
                    disabled={loading}
                    onClick={() => openDrawer(row)}
                    danger
                    block
                  >
                    Booking Detail
                  </Button>
                </Col>
              )}

              {row.booking_status === "2" &&
                row.payment_status === "1" &&
                type !== "multi_booking" && (
                  <Col span={24}>
                    <Button
                      onClick={() => {
                        const id = row.id;
                        const encodedId = btoa(id.toString());
                        const url = `${BOOKING_INVOICE}${encodedId}`;
                        window.open(url, "_blank");
                      }}
                      loading={loading}
                      disabled={loading}
                      block
                    >
                      INVOICE
                    </Button>
                  </Col>
                )}
              {row.booking_status === "2" &&
                row.payment_status === "1" &&
                type === "multi_booking" && (
                  <Col span={24}>
                    <Button
                      onClick={() => {
                        const id = row.multi_book_id;
                        const encodedId = btoa(id.toString());
                        const url = `${BOOKING_MULTI_INVOICE}${encodedId}`;
                        window.open(url, "_blank");
                      }}
                      loading={loading}
                      disabled={loading}
                      block
                    >
                      MULTI INVOICE
                    </Button>
                  </Col>
                )}

              {row.booking_status !== "3" && type === "completed_checkin" && (
                <Col span={24}>
                  <Button
                    block
                    onClick={() => {
                      setEditBookingVisible(true);
                      setSelectedBooking(row);
                    }}
                  >
                    Edit Booking
                  </Button>
                </Col>
              )}
              {row.booking_status === "1" && (
                <>
                  <Col span={12}>
                    <Button
                      loading={loading}
                      disabled={loading}
                      onClick={() => openOrderDrawer(row)}
                      danger
                      block
                    >
                      Orders
                    </Button>
                  </Col>
                  <Col span={12}>
                    <Button
                      onClick={() => navigate("/order/product/" + row.id)}
                      loading={loading}
                      disabled={loading}
                      block
                    >
                      Add Order
                    </Button>
                  </Col>
                  <Col span={12}>
                    <Button
                      loading={loading}
                      disabled={loading}
                      onClick={() => openExtraService(row, "applied")}
                      danger
                      block
                    >
                      Services
                    </Button>
                  </Col>
                  <Col span={12}>
                    <Button
                      onClick={() => openExtraService(row, "new_apply")}
                      loading={loading}
                      disabled={loading}
                      block
                    >
                      Add Service
                    </Button>
                  </Col>
                </>
              )}

              {row.booking_status === "4" && (
                <Col span={24}>
                  <Button
                    onClick={() =>
                      row.advance_amount === null ||
                      parseInt(row.advance_amount) === 0.0
                        ? handleModalOpen(row)
                        : checkin(row.id)
                    }
                    loading={loading}
                    disabled={loading}
                    block
                  >
                    Check-In
                  </Button>
                </Col>
              )}

              {row.payment_method === "razorpay" &&
                row.payment_status === "0" && (
                  <Col span={24}>
                    <Button
                      onClick={() => pay_init(row.id)}
                      loading={loading}
                      disabled={loading}
                      block
                    >
                      Pay
                    </Button>
                  </Col>
                )}

              {row.booking_status === "0" && (
                <>
                  <Col span={12}>
                    <Button
                      onClick={() => bookingAction(row.id, "accept")}
                      loading={loading}
                      disabled={loading}
                      block
                    >
                      Accept
                    </Button>
                  </Col>
                  <Col span={12}>
                    <Button
                      loading={loading}
                      disabled={loading}
                      danger
                      block
                      onClick={() => {
                        setSelectedBookingId(row.id);
                        setCancelBooking(row);
                        setIsCancelModalVisible(true);
                      }}
                    >
                      Reject
                    </Button>
                  </Col>
                </>
              )}

              {(row.booking_status === "0" || row.booking_status === "4") && (
                <>
                  <Col span={24}>
                    <Button
                      loading={loading}
                      disabled={loading}
                      danger
                      block
                      onClick={() => {
                        setSelectedBookingId(row.id);
                        setCancelBooking(row);
                        setIsCancelModalVisible(true);
                      }}
                    >
                      Cancel
                    </Button>
                  </Col>
                </>
              )}

              {row.booking_status === "1" && (
                <Col span={24}>
                  <Popconfirm
                    title="Checkout the booking"
                    description="Are you sure to checkout?"
                    onConfirm={() => openModel(row)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button loading={loading} disabled={loading} block>
                      Checkout
                    </Button>
                  </Popconfirm>
                </Col>
              )}
            </Row>
          ),
        }));
        setState(roomData);
        setFilteredData(roomData);
        setLoading(false);
      } else {
        displayMessage(INFO_MSG_TYPE, data.message);
        setState([]);
        setFilteredData([]);
        setLoading(false);
      }
    };
    const errorFn = function () {
      setState([]);
      setFilteredData([]);
      setLoading(false);
    };
    getAPI(ALL_BOOKING + type, successFn, errorFn, {});
  };

  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = state.filter(
      (room) =>
        room?.order_id?.includes(value) ||
        room?.invoice_id?.includes(value) ||
        room?.booking_status_n?.includes(value) ||
        room.room_no_n.includes(value) ||
        room?.customer_name?.includes(value) ||
        room?.phone?.includes(value),
    );
    setFilteredData(filtered);
  };

  const handleModalOpen = (booking) => {
    setSelectedBooking(booking);
    setAdvModalVisible(true);
  };

  const handleModalClose = () => {
    setAdvModalVisible(false);
    setAdvanceAmount("");
    setSelectedBooking(null);
  };
  const handleAdvancePaySubmit = () => {
    if (parseFloat(advanceAmount) <= 0) {
      displayMessage(
        ERROR_MSG_TYPE,
        "Please enter a valid amount for advance payment",
      );
      return;
    }
    adv_pay_init(selectedBooking.id, advanceAmount);
    handleModalClose(); // Close the modal after submitting
  };

  const openExtraService = (data, type) => {
    setSelectedBooking(data);
    if (type === "new_apply") {
      setIsServiceModal(true);
      setIsServicesModal(false);
    } else {
      setIsServicesModal(true);
      setIsServiceModal(false);
    }
  };

  // Extra Service Modal
  const [isServiceModal, setIsServiceModal] = useState(false);

  // Booking Extra Services Modal
  const [isServicesModal, setIsServicesModal] = useState(false);

  const getPageHeading = () => {
    let heading = "";
    switch (type) {
      case "all":
        heading = "All Bookings";
        break;

      case "pending_checkin":
        heading = "Pending Checkin Bookings";
        break;

      case "upcoming_checkin":
        heading = "Upcoming Checkin Bookings";
        break;

      case "delayed_checkin":
        heading = "Delayed Checkin Bookings";

        break;

      case "upcoming_checkout":
        heading = "Upcoming Checkout Bookings";
        break;

      case "delayed_checkout":
        heading = "Delayed Checkout Bookings";
        break;

      case "active":
        heading = "Active Bookings";
        break;

      case "multi_booking":
        heading = "Completed Multi Bookings";
        break;

      case "completed_checkin":
        heading = "Completed Bookings";
        break;

      default:
        return "Manage Bookings";
    }
    return heading;
  };

  const columns = [
    {
      title: "Sno",
      dataIndex: "ID",
      width: 50,
    },

    type === "multi_booking" && {
      title: "M-B ID",
      dataIndex: "multi_book_id",
      width: 50,
    },
    {
      title: "Room No",
      dataIndex: "room_no",
      width: 50,
    },
    {
      title: "Customer",
      dataIndex: "name",
      width: 100,
    },
    {
      title: "Segment",
      dataIndex: "segment",
      width: 100,
    },
    {
      title: "Checkin Date",
      dataIndex: "checkin_date",
      width: 150,
    },
    {
      title: "Checkout Date",
      dataIndex: "checkout_date",
      width: 150,
    },
    {
      title: "Booking Status",
      dataIndex: "booking_status",
      width: 50,
    },
    {
      title: "Payment Status",
      dataIndex: "payment_status",
      width: 50,
    },
    LS_SERVICE.get("user_type") !== "customer" &&
    LS_SERVICE.get("user_type") !== "accountant" &&
    LS_SERVICE.get("user_type") !== "biller" &&
    LS_SERVICE.get("user_type") !== "kitchen"
      ? {
          title: "Action",
          dataIndex: "Action",
          width: 100,
        }
      : null,
  ].filter(Boolean);

  return (
    <>
      <Layout>
        <LayoutHeader />
        <Content>
          <Card
            title={getPageHeading()}
            extra={
              <Space>
                <Input
                  placeholder="Search by Name or Room No"
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                  style={{ width: 300 }}
                />
                <Button onClick={() => navigate("/booking-request")}>
                  Create Booking Request <PlusOutlined />
                </Button>
              </Space>
            }
            bordered={true}
          >
            <Table
              loading={loading}
              columns={columns}
              dataSource={filteredData}
              pagination={{ pageSize: 10 }}
              scroll={{ x: 240 }}
            />
          </Card>
          {/* Booking View */}
          {isDrawerOpen && selectedBooking && (
            <BookingDetailDrawer
              open={isDrawerOpen}
              onClose={closeDrawer}
              booking={selectedBooking}
            />
          )}
          {/* Booking Order View */}
          {isOrderDrawerOpen && selectedBooking && (
            <BookingOrderDrawer
              open={isOrderDrawerOpen}
              onClose={closeOrderDrawer}
              booking={selectedBooking}
            />
          )}
          {/* Checkout Modal */}
          {isModalVisible && selectedBooking && (
            <CheckoutModal
              visible={isModalVisible}
              onClose={handleClose}
              booking={selectedBooking} // Pass the booking data here
            />
          )}

          {/* Cancel Booking Modal (reusable: asks full refund vs policy) */}
          {isCancelModalVisible && cancelBooking && (
            <CancelBookingModal
              visible={isCancelModalVisible}
              booking={cancelBooking}
              onClose={() => setIsCancelModalVisible(false)}
              onConfirmed={() => {
                setIsCancelModalVisible(false);
                setCancelBooking(null);
                setSelectedBookingId(null);
                getData();
              }}
            />
          )}

          <Modal
            title="Advance Payment"
            visible={advModalVisible}
            onCancel={handleModalClose}
            footer={[
              <Button key="cancel" onClick={handleModalClose}>
                Cancel
              </Button>,
              <Button
                key="submit"
                type="primary"
                onClick={handleAdvancePaySubmit}
                loading={loading}
              >
                Submit
              </Button>,
            ]}
          >
            <Space direction="vertical" style={{ width: "100%" }}>
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <b>Amount:</b>
                  <Input
                    type="number"
                    value={advanceAmount}
                    onChange={(e) => setAdvanceAmount(e.target.value)}
                    placeholder="Enter amount"
                    min={0}
                  />
                </Col>
                <Col span={12}>
                  <b>Payment Method: </b>
                  <Select
                    value={paymentMethod}
                    onChange={(value) => setPaymentMethod(value)}
                    style={{ width: "100%" }}
                    options={PAYMENT_METHOD.map((method) => ({
                      ...method,
                      disabled:
                        method.value === "razorpay" &&
                        parseFloat(advanceAmount || 0) <= 0,
                    }))}
                  />
                </Col>
              </Row>
            </Space>
          </Modal>
          {/* Extra Service Modal */}
          {isServiceModal && selectedBooking && (
            <ExtraServiceModal
              visible={isServiceModal}
              onClose={handleClose}
              booking_id={selectedBooking.id}
            />
          )}

          {/* Booking Extra Service Modal */}
          {isServicesModal && selectedBooking && (
            <BookingAppliedServiceModal
              visible={isServicesModal}
              onClose={handleClose}
              booking_id={selectedBooking.id}
            />
          )}
          {/* Booking Edit Modal */}
          {editBookingVisible && selectedBooking && (
            <BookingEditModal
              visible={editBookingVisible}
              onClose={handleClose}
              booking={selectedBooking}
            />
          )}
        </Content>
        <LayoutFooter />
      </Layout>
    </>
  );
}

export default BookingTable;
